import theme from 'config/theme';
import Spacing from 'components/Spacing';
import { getCommunityImageUrl } from 'helpers/imageUrls';
import { Row, RowToGrid } from 'components/Row';
import { ButtonBrand } from 'components/ButtonBrand';
import { Eyebrow, H3, H4 } from 'components/Typography';
import { TopIssueCard } from 'components/Cards/TopIssueCard';
import { GradientBorderCard } from 'components/Cards/GradientBorderCard';
import { getPathWithRef } from 'helpers/utils';
import {
  Container,
  Description,
  InnerGradientBox,
  StyledImage,
  Title,
  TopIssueContainer,
} from './styled';
import { FC } from 'react';
import { IPage } from 'store/donatePage/types';
import { SetsData } from 'store/sets/types';

interface Props {
  setsData: SetsData;
  page?: IPage;
}

export const OtherIssues: FC<Props> = ({ setsData, page }) => {
  const setTags = setsData?.set_pages?.map(set => set.page_id);
  const issues = page
    ? [page]
        ?.filter(page => setTags?.includes(page.id))
        ?.map(page => ({
          ...page,
          raised:
            setsData?.set_pages?.find(set => set.page_id === page.id)?.page_fundraising_raised ||
            '',
        }))
    : [];
  const otherIssues = issues?.filter(issue => issue.id !== page?.id);

  return (
    <Container $textAlign="center">
      <Title>Other Oath Issues</Title>
      <Description>Help us get to our $1 million goal by contributing to other issues</Description>
      <Spacing $size={16} />
      <RowToGrid $justifyContent="center">
        {otherIssues?.slice(0, 2)?.map((issue, index) => (
          <TopIssueContainer key={index}>
            <TopIssueCard issue={issue} />
          </TopIssueContainer>
        ))}
        <GradientBorderCard borderType="full" width="375px">
          <InnerGradientBox>
            <Eyebrow $color={theme.colors.inkBlue}>can’t decide?</Eyebrow>
            <H3>Split your contribution to all {issues?.length} issues</H3>
            <Spacing $size={16} />
            {issues?.map(issue => (
              <Row $justifyContent="center" key={issue.id}>
                <StyledImage alt={`${issue.value} graphic`} src={getCommunityImageUrl(issue)} />
                <Spacing $isVertical $size={8} />
                <H4>{issue.value}</H4>
              </Row>
            ))}
            <Spacing $size={24} />
            <ButtonBrand
              href={getPathWithRef(`/donate?p=${setsData?.querystring}`)}
              target="_blank"
            >
              {setsData?.set_misc?.donate_custom_1 || `DONATE TO ALL ${issues?.length} ISSUES`}
            </ButtonBrand>
          </InnerGradientBox>
        </GradientBorderCard>
      </RowToGrid>
    </Container>
  );
};
